$(document).ready(function () {
    //size finder activator
    const sizeFinder = $('#size-finder');
    const sizeFinderBtn = $('.consult-size-btn');
    const editInfoBtn = $('.edit-info');

    var bustSize = $('#bust-size');
    var waistSize = $('#waist-size');
    var hipsSize = $('#hips-size');

    var topVal = $('.top-val');
    var bottomVal = $('.bottom-val');
    var onePieceVal = $('.one-piece-val');

    $('.size-finder-activator').on('click', function (){
        $(sizeFinder).fadeIn(500);
        $('html').addClass('block-scroll');
    });

    //click close button close panel size and finded size
    $('.size-finder-close').on('click', function (){
        $(sizeFinder).fadeOut(500);
        $('.size-finded-container').fadeOut(1000);
        $("html").removeClass("block-scroll");
    });


    //size finder button & open second panel size finded
    $(sizeFinderBtn).on('click', function(e){
        e.preventDefault();
        SizeCalculate();
        $('.size-finded-container').fadeIn(500);
    });

    $(editInfoBtn).on('click', function(e){
        e.preventDefault();
        $('.size-finded-container').fadeOut(500);
    });


    function SizeCalculate() {
        //size bust
        if($(bustSize).val() == "82-86"){
            $(topVal).val('XS');
        }
        else if($(bustSize).val() == "87-91"){
            $(topVal).val('S');
        }
        else if($(bustSize).val() == "92-96"){
            $(topVal).val('M');
        }
        else if($(bustSize).val() == "97-101"){
            $(topVal).val('L');
        }
        else if($(bustSize).val() == "102-106"){
            $(topVal).val('XL');
        }

        //size waist
        if($(waistSize).val() == "66-70"){
            $(bottomVal).val('XS');
        }
        else if($(waistSize).val() == "71-75"){
            $(bottomVal).val('S');
        }
        else if($(waistSize).val() == "76-80"){
            $(bottomVal).val('M');
        }
        else if($(waistSize).val() == "81-85"){
            $(bottomVal).val('L');
        }
        else if($(waistSize).val() == "86-90"){
            $(bottomVal).val('XL');
        }

        //size hips
        if($(hipsSize).val() == "91-95"){
            $(onePieceVal).val('XS');
        }
        else if($(hipsSize).val() == "96-100"){
            $(onePieceVal).val('S');
        }
        else if($(hipsSize).val() == "101-105"){
            $(onePieceVal).val('M');
        }
        else if($(hipsSize).val() == "106-110"){
            $(onePieceVal).val('L');
        }
        else if($(hipsSize).val() == "111-115"){
            $(onePieceVal).val('XL');
        }
    }
});